export function addMetaPixel(pixelId) {
	const head = document.head || document.getElementsByTagName('head')[0];
	if (!head) {
		console.error('No head element found in the document.');
		return;
	}

	// Create script element for Facebook Pixel
	const metaPixelTag = document.createElement('script');
	metaPixelTag.textContent = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '${pixelId}');fbq('track', 'PageView');`;
	head.appendChild(metaPixelTag);

	// Create image element for noscript pixel
	head.insertAdjacentHTML('beforeend',
		`<noscript>
            <img height="1" width="1" style="display:none"
                src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1" />
        </noscript>`
	);
}

export function sendPageViewEvent() {
	if (typeof window.fbq !== 'undefined') {
		window.fbq('track', 'PageView');
	}
}

export function sendAddToCartEvent(viajeId, currency, price) {
	if (typeof window.fbq !== 'undefined') {
		window.fbq('track', 'AddToCart', {
			content_ids: [viajeId],
			content_type: 'product',
			currency: currency,
			value: price,
		});
	}
}

export function sendInitiateCheckoutEvent(viajeId, numReservas, currency, price) {
	if (typeof window.fbq !== 'undefined') {
		window.fbq('track', 'InitiateCheckout', {
			content_ids: [viajeId],
			num_items: numReservas,
			currency: currency,
			value: price,
		});
	}
}

export function sendPurchaseEvent(viajeId, numReservas, currency, price) {
	if (typeof window.fbq !== 'undefined') {
		window.fbq('track', 'Purchase', {
			content_ids: [viajeId],
			num_items: numReservas,
			currency: currency,
			value: price,
		});
	}
}

export function sendViewContentEvent(viajeId, currency, price) {
	if (typeof window.fbq !== 'undefined') {
		window.fbq('track', 'ViewContent', {
			content_ids: [viajeId],
			content_type: 'product',
			currency: currency,
			value: price,
		});
	}
}

export default {
	sendAddToCartEvent,
	sendInitiateCheckoutEvent,
	sendPageViewEvent,
	sendPurchaseEvent,
	sendViewContentEvent,
}


